<template>

    <v-button id="btn-google" btn-style="google" data-onsuccess="onSignIn" :disabled="loading" btn-block>
        <i class="fab fa-google"></i>
        <v-loader v-if="loading" size="sm" />
        <span v-else>Continue with Google</span>
    </v-button>

</template>

<style scoped lang="scss">

    #btn-google {
        display: flex !important;
        i {
            align-items: center;
            color: #DB4437;
            display: flex;
            font-size: 16px;
            justify-content: center;
            left: 0;
            margin: 0 15px;
            height: 100%;
            position: absolute;
            top: 0;
        }
        .loader {
            margin: 0;
        }
    }

</style>

<script>

export default {

    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },

}

</script>
